import { ref } from 'vue';

export const $_at_user = ref(null);
